<template>
  <div>
    <tiger-category-strip :items="sections" />
    <section v-for="section in sections" :id="section.id" :key="section.id" class="guide-section">
      <div class="sectionheading">
        <h2>{{ section.label }}</h2>
      </div>
      <div v-for="step in section.steps" :key="step.title" class="step">
        <div class="text">
          <h3>{{ step.title }}</h3>
          <div class="bodytext" v-text="step.body" />
        </div>
        <div v-if="step.images.length" class="screenshot-grid" :class="{ one: step.images.length === 1 }">
          <tiger-shot v-for="image in step.images" :key="image" :src="image" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TigerCategoryStrip from './tigerCategoryStrip.vue'
import TigerShot from './tigerShot.vue'

const sections = [
  {
    id: 'deposit',
    label: '仮想通貨での入金方法',
    steps: [
      {
        title: 'ステップ 1',
        body: 'ホーム画面の「入金」をタップ',
        images: ['sup/help/deposit_1.webp']
      },
      {
        title: 'ステップ 2',
        body: '➊ 「仮想通貨」を選択\n\n➋ 入金通貨およびネットワークを選択\n\n➌ 個人専用の入金アドレスとQRコードが表示される',
        images: ['sup/help/deposit_2.webp']
      },
      {
        title: 'ステップ 3',
        body: 'ご利用の取引所またはウォレットから、\n個人専用の入金アドレスへ希望金額を送金すると\n「該当仮想通貨のウォレット」へ即時反映\n\n※【注意】XRPで入金する場合はタグの入力が必須です。\n未入力の場合、資金を失う恐れがあります。',
        images: ['sup/help/deposit_3.webp']
      }
    ]
  },
  {
    id: 'withdrawal',
    label: '仮想通貨での出金方法',
    steps: [
      {
        title: 'ステップ 1',
        body: '➊ 残高表示部分ををタップ\n\n➋ 「出金」をタップ',
        images: ['sup/help/withdraw_1.webp']
      },
      {
        title: 'ステップ 2',
        body: '➊ 「出金」を選択\n\n➋ 出金通貨およびネットワークを選択\n\n➌ 金額を入力 ※最低出金額6000円\n\n➍ 出金先アドレスを入力\n\n➎ 出金パスワードを入力\n\n➏ 「送信する」をタップすると出金申請を提出完了\n\n※【注意】XRPで出金する場合はタグの入力が必須です。未入力の場合、資金を失う恐れがあります。',
        images: ['sup/help/withdraw_2_1.webp', 'sup/help/withdraw_2_2.webp', 'sup/help/withdraw_2_3.webp']
      },
      {
        title: 'ステップ 3',
        body: '出金申請の審査が終了後に出金完了\n\n※出金申請後に出金審査完了までお待ちください。出金処理が完了すると通知メールが送信されます。',
        images: []
      }
    ]
  }
]

export default {
  name: 'TigerPayments',
  components: {
    TigerCategoryStrip,
    TigerShot
  },
  data() {
    return {
      sections
    }
  }
}
</script>
